import React, { useEffect, useRef, useState } from 'react';

const RESULTADOS_IMG = 'https://customer-assets.emergentagent.com/job_f1b1dda7-5397-45e3-bbb9-20abbfb4291c/artifacts/vst3thoq_Design%20sem%20nome%20%286%29.png';

// Seção "Resultados Reais" com parallax + zoom (1.0→1.1) + fade out/in ao rolar.
// Performático: usa requestAnimationFrame + listener passivo + translate3d (GPU).
const ParallaxResultados = () => {
  const ref = useRef(null);
  const [style, setStyle] = useState({ transform: 'translate3d(0,0,0) scale(1)', opacity: 0 });

  useEffect(() => {
    let raf = null;
    const update = () => {
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const total = vh + rect.height;
      let p = (vh - rect.top) / total; // 0 ao entrar pela base, 1 ao sair pelo topo
      p = Math.min(1, Math.max(0, p));

      const translate = (p - 0.5) * 70;        // parallax: -35px..35px
      const scale = 1 + p * 0.1;               // zoom 1.0 -> 1.1
      let opacity = 1;
      if (p < 0.18) opacity = p / 0.18;        // fade in na entrada
      else if (p > 0.62) opacity = Math.max(0, 1 - (p - 0.62) / 0.38); // fade out na saída

      setStyle({ transform: `translate3d(0, ${translate.toFixed(1)}px, 0) scale(${scale.toFixed(3)})`, opacity: Number(opacity.toFixed(3)) });
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { update(); raf = null; });
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <section data-testid="resultados-reais-section" className="bg-orange-50/60 py-16 md:py-24 overflow-hidden">
      <div className="container-hm px-6">
        <div ref={ref} className="relative max-w-5xl mx-auto rounded-3xl overflow-hidden card-shadow will-change-transform">
          <img
            src={RESULTADOS_IMG}
            alt="Resultados Reais — Parcerias fortes que transformam. HM Talent."
            loading="lazy"
            className="w-full h-auto block select-none pointer-events-none"
            style={style}
            draggable={false}
          />
        </div>
      </div>
    </section>
  );
};

export default ParallaxResultados;
